define((require) => {
    "use strict";

    const BreakpointGroup        = require("shared/ui/breakpoint/BreakpointGroup");
    const Configuration          = require("shared/xp/config");
    /**
     * A model of a breakpoint solely for getting Export to work
     * This allows us to call to Akamai to get the last pushed experience whereas normal breakpoints call to java
     *
     * @class BreakpointExportModel
     * @constructor
     */
    return  BreakpointGroup.extend("BreakpointExportModel", {
        url() {
            const urlBase = Configuration.default.adminApiBaseUrl;  // viewerBaseUrl calls S3
            return `${urlBase}/api/groups/${this.get("id")}`;
        }
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/breakpoint/BreakpointExportModel.js